module.exports = __webpack_public_path__ + "static/media/g-icon-delete.7c9cb83a.svg";